import { intervalToDuration, isAfter } from 'date-fns';

export type TimeLeftType = {
  timeLeft: string;
  interval: number;
};

export const getTimeLeft = (closingTime: string): TimeLeftType => {
  const currentTime = new Date();
  const closingDate = new Date(closingTime);
  const { years, months, days, hours, minutes, seconds } = intervalToDuration({
    start: currentTime,
    end: closingDate,
  });
  if (isAfter(currentTime, closingDate)) {
    return { timeLeft: '', interval: 0 };
  }

  if (years) return { timeLeft: `${years}Y ${months}M left`, interval: 600000 };
  else if (months)
    return { timeLeft: `${months}M ${days}d left`, interval: 600000 };
  else if (days)
    return { timeLeft: `${days}d ${hours}h left`, interval: 600000 };
  else if (hours)
    return { timeLeft: `${hours}h ${minutes}m left`, interval: 20000 };
  else return { timeLeft: `${minutes}m ${seconds}s left`, interval: 1000 };
};

export const getTimeLeftShort = (closingTime: number): TimeLeftType => {
  const currentTime = new Date();
  const closingDate = new Date(closingTime * 1000);
  const { years, months, days, hours, minutes, seconds } = intervalToDuration({
    start: currentTime,
    end: closingDate,
  });
  if (isAfter(currentTime, closingDate)) {
    return { timeLeft: '', interval: 0 };
  }

  if (years) return { timeLeft: `${years}Y ${months}M`, interval: 600000 };
  else if (months) return { timeLeft: `${months}M ${days}d`, interval: 600000 };
  else if (days) return { timeLeft: `${days}d ${hours}h`, interval: 600000 };
  else if (hours) return { timeLeft: `${hours}h ${minutes}m`, interval: 20000 };
  else return { timeLeft: `${minutes}m ${seconds}s `, interval: 1000 };
};

export const getTimeLeftLong = (closingTime: number): TimeLeftType => {
  const currentTime = new Date();
  const closingDate = new Date(closingTime * 1000);
  const { years, months, days, hours, minutes, seconds } = intervalToDuration({
    start: currentTime,
    end: closingDate,
  });
  if (isAfter(currentTime, closingDate)) {
    return { timeLeft: '', interval: 0 };
  }

  if (years)
    return { timeLeft: `${years}Y ${months}M ${days}d `, interval: 600000 };
  else if (months)
    return { timeLeft: `${months}M ${days}d ${hours}h `, interval: 600000 };
  else if (days)
    return { timeLeft: `${days}d ${hours}h ${minutes}m `, interval: 20000 };
  else if (hours)
    return { timeLeft: `${hours}h ${minutes}m ${seconds}s `, interval: 1000 };
  else return { timeLeft: `${minutes}m ${seconds}s `, interval: 1000 };
};

export const getTimeLeftMinimal = (closingTime: number): TimeLeftType => {
  const currentTime = new Date();
  const closingDate = new Date(closingTime * 1000);
  const { minutes, seconds } = intervalToDuration({
    start: currentTime,
    end: closingDate,
  });

  if (isAfter(currentTime, closingDate)) {
    return { timeLeft: '', interval: 0 };
  }

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  return {
    timeLeft: `${formattedMinutes}:${formattedSeconds}`,
    interval: 1000,
  };
};
